"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownDefaultText = exports.StyledDropdownList = exports.StyledDropdownListContainer = exports.StyledDropdownContainer = exports.getDropdownListContainerHeight = exports.ITEM_HEIGHT_TEXT = exports.ITEM_PADDING_RIGHT = exports.ITEM_PADDING_MID = exports.ITEM_PADDING_LEFT = exports.ITEM_RIGHT_WIDTH = exports.ITEM_CENTER_WIDTH = exports.ITEM_LEFT_WIDTH = exports.SIZE_ARROW = exports.SIZE_KEYBOARD = exports.HEADER_HEIGHT_TEXT = exports.PADDING_HORIZONTAL_ARROW = exports.PADDING_VERTICAL_ARROW = exports.PADDING_VERTICAL_TEXT = exports.PADDING_VERTICAL_KEYBOARD = exports.PADDING_HORIZONTAL_KEYBOARD = exports.HEADER_RIGHT_WIDTH = exports.HEADER_CENTER_WIDTH = exports.HEADER_LEFT_WIDTH = exports.ICON_ARROW_DOWN = exports.ICON_ARROW_UP = exports.ICON_KEYBOARD = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.ICON_KEYBOARD = 'keyboard';
exports.ICON_ARROW_UP = 'dropdownUp';
exports.ICON_ARROW_DOWN = 'dropdownDown';
exports.HEADER_LEFT_WIDTH = '24';
exports.HEADER_CENTER_WIDTH = '535';
exports.HEADER_RIGHT_WIDTH = '18';
exports.PADDING_HORIZONTAL_KEYBOARD = '12';
exports.PADDING_VERTICAL_KEYBOARD = '14.5';
exports.PADDING_VERTICAL_TEXT = '14.25';
exports.PADDING_VERTICAL_ARROW = '19';
exports.PADDING_HORIZONTAL_ARROW = '16';
exports.HEADER_HEIGHT_TEXT = '19.5';
exports.SIZE_KEYBOARD = '19';
exports.SIZE_ARROW = '10';
exports.ITEM_LEFT_WIDTH = '110px';
exports.ITEM_CENTER_WIDTH = '402px';
exports.ITEM_RIGHT_WIDTH = '58px';
exports.ITEM_PADDING_LEFT = '12';
exports.ITEM_PADDING_MID = '6';
exports.ITEM_PADDING_RIGHT = '22';
exports.ITEM_HEIGHT_TEXT = '20';
const getDropdownListContainerHeight = (props) => {
    const hasOverflow = props.totalOptions < props.maxOptions;
    const totalOptionsHeight = props.totalOptions * 48;
    const maxOptionsHeight = props.maxOptions * 48;
    const finalHeight = hasOverflow
        ? totalOptionsHeight
        : maxOptionsHeight;
    return props.hasTitle ? finalHeight + 30 : finalHeight;
};
exports.getDropdownListContainerHeight = getDropdownListContainerHeight;
exports.StyledDropdownContainer = Theme_1.styled.div `
  margin: 0 auto;
  width: 616px;
`;
exports.StyledDropdownListContainer = Theme_1.styled.div `
  align: center;
  margin: 0 auto;
  height: ${(props) => (0, exports.getDropdownListContainerHeight)(props)}px;
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.gray[30]};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.gray[50]};
  }
`;
exports.StyledDropdownList = Theme_1.styled.ul `
  margin-block-start: 0em;
  align: center;
  width: 100%;
  font-weight: 500;
  font-family: proxima-nova, arial, sans-serif;
  margin-block-end: 0em;
  padding-inline-start: 0px;
`;
exports.StyledDropdownDefaultText = Theme_1.styled.p `
  align: center;
  margin: 0.4em;
  font-weight: 500;
  font-size: 12px;
  font-family: proxima-nova, arial, sans-serif;
  color: ${(props) => props.theme.colors.black};
`;
//# sourceMappingURL=Dropdown.styles.js.map